import _export from "../internals/export";
import _functionUncurryThis from "../internals/function-uncurry-this";
import _fails from "../internals/fails";
var $ = _export;
var uncurryThis = _functionUncurryThis;
var fails = _fails;

// IE8- non-standard case
var FORCED = fails(function () {
  // eslint-disable-next-line es/no-date-prototype-getyear-setyear -- detection
  return new Date(1600000000000).getYear() !== 120;
});
var getFullYear = uncurryThis(Date.prototype.getFullYear);

// `Date.prototype.getYear` method
// https://tc39.es/ecma262/#sec-date.prototype.getyear
$({
  target: "Date",
  proto: true,
  forced: FORCED
}, {
  getYear: function getYear() {
    return getFullYear(this) - 1900;
  }
});
export default {};